/**
 * @desc 函数防抖
 * @param func (function) 函数
 * @param wait (number) 延迟执行毫秒数
 * @param immediate (boolean) true 表立即执行，false 表非立即执行
 */
export function debounce(func, wait, immediate) {
  let timeout;
  return function() {
    let context = this;
    let args = arguments;
    if (timeout) clearTimeout(timeout);
    if (immediate) {
      let callNow = !timeout;
      timeout = setTimeout(function() {
        timeout = null;
      }, wait);
      if (callNow) func.apply(context, args);
    } else {
      timeout = setTimeout(function() {
        func.apply(context, args);
      }, wait);
    }
  };
}

/**
 * @desc 函数节流
 * @param func (function) 函数
 * @param wait (number) 延迟执行毫秒数
 * @param type  (number) 1 表时间戳版，2 表定时器版
 */
export function throttle(func, wait, type) {
  let previous, timeout;
  if (type === 1) {
    previous = 0;
  }

  return function() {
    let context = this;
    let args = arguments;
    if (type === 1) {
      let now = Date.now();

      if (now - previous > wait) {
        func.apply(context, args);
        previous = now;
      }
    } else if (type === 2) {
      if (!timeout) {
        timeout = setTimeout(function() {
          timeout = null;
          func.apply(context, args);
        }, wait);
      }
    }
  };
}

// 判断系统是否设置支持语言，没有则使用全部
export function handleFilterLang(vm) {
    let sysLang = vm.$store.state.sysSetLang;
    let supportLangList = vm.$store.state.supportLangList;
    if(sysLang.length) {
        return supportLangList.filter(i =>  sysLang.includes(i.value));
    }
    return []
    // return supportLangList;

}

// 滚动回到页面顶部
export function handleScrollToTop() {
    let el = document.getElementsByClassName("scroller")[1];
    el.scrollTop = 0;
}

// 辅助函数：根据传入的参数过滤/新添字段并最终返回格式化好的数据
export function handleFilterData(target,tpl, langList) {
  let keys = Object.keys(target);
  target = JSON.parse(JSON.stringify(target));

  // 先过滤不存在的
  keys.forEach(key => {
    if (!langList.includes(key)) {
      delete target[key];
    }
  })

  keys = Object.keys(target);

  // 新增
  langList.forEach(lang => {
    if (!keys.includes(lang)) {
      target[lang] = tpl;
    }
  })
  return target;
}
